import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconGlobe: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.028 2.002C17.529 2.018 22 6.496 22 12C22 17.504 17.529 21.983 12.028 21.998C12.026 21.998 12.023 22 12.02 22C12.019 22 12.0183 21.9998 12.0175 21.9995C12.0168 21.9993 12.016 21.999 12.015 21.999C12.0132 21.999 12.0112 21.9992 12.009 21.9994C12.0063 21.9997 12.0033 22 12 22C6.486 22 2 17.514 2 12C2 6.487 6.486 2 12 2C12.0026 2 12.0056 2.00028 12.0083 2.00054C12.0108 2.00078 12.0131 2.001 12.015 2.001C12.0176 2.001 12.02 2.00128 12.0222 2.00154C12.0242 2.00178 12.0261 2.002 12.028 2.002ZM9.079 11C9.385 7.728 11.059 5.45 12.026 4.397C13.026 5.468 14.674 7.725 14.959 11H9.079ZM7.065 11C7.285 8.137 8.386 5.927 9.438 4.429C6.586 5.397 4.455 7.928 4.069 11H7.065ZM4.069 13H7.061C7.267 15.862 8.344 18.056 9.407 19.561C6.57 18.584 4.454 16.061 4.069 13ZM14.617 19.552C15.666 18.054 16.757 15.851 16.975 13H19.93C19.547 16.052 17.441 18.57 14.617 19.552ZM14.962 13H9.08C9.359 16.272 10.965 18.498 12.012 19.608C12.978 18.555 14.656 16.277 14.962 13ZM19.93 11H16.978C16.773 8.151 15.708 5.964 14.65 4.461C17.458 5.451 19.549 7.96 19.93 11Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconGlobe;
